import script from "./TimeWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeWidget.vue?vue&type=script&setup=true&lang=js"

import "./TimeWidget.vue?vue&type=style&index=0&id=5c4b1642&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4b1642"]])

export default __exports__